import React from "react";
import useTranslation from "next-translate/useTranslation";
import FacebookButton from "../../../components/ui/facebook-button";
import Popup from "../../../components/ui/popup";
import { setLoadingBar } from "../../../redux/siteData";
import { setFbId } from "../../../redux/user";
import { api } from "../../../services/api";

export function addFacebook() {
  setLoadingBar(true);

  window.FB.login(
    (response) => {
      if (response.status === "connected") {
        const accessToken = response.authResponse.accessToken;

        api
          .post("/auth/facebook/add", { access_token: accessToken })
          .then((response) => {
            setFbId(response.data.fbId);
          })
          .catch((e) => {
            console.log(e);
          })
          .then(() => {
            setLoadingBar(false);
          });
      } else {
        setLoadingBar(false);
      }
    },
    { scope: "gaming_profile" }
  );
}

export default function AddProfilePic({ onClose }) {
  const { t } = useTranslation("common");
  const { t: profileT } = useTranslation("auth");

  function handleClick() {
    addFacebook();
    onClose();
  }

  return (
    <Popup
      title={profileT("Get your profile picture?")}
      onClose={() => onClose()}
    >
      <FacebookButton onClick={handleClick} text={t("Connect with Facebook")} />
    </Popup>
  );
}
